import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AccountOrderViewComponentDef } from '@df/account/v2/order/view/account-order-view.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { FormatDatePipe } from '@df/ui/display/format-date.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { AccountBackComponent } from '../../back/account-back.component';
import { AccountViewComponent } from '../../view/account-view.component';
import { AccountOrderViewItemComponent } from './item/account-order-view-item.component';
@Component({
    selector: 'account-order-view',
    templateUrl: './account-order-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        TranslationModule,
        AccountBackComponent,
        PriceComponent,
        FormatDatePipe,
        AccountOrderViewItemComponent,
        SizeClassDirective,
        RouterLink
    ]
})
export class AccountOrderViewComponent extends AccountOrderViewComponentDef implements OnInit, OnDestroy {
    constructor(
        private accountViewComponent: AccountViewComponent,
    ) {
        super();
        this.accountViewComponent.forceContentCols = 6;
    }
    override ngOnDestroy(): void {
        this.accountViewComponent.forceContentCols = undefined;
        super.ngOnDestroy();
    }
    get totals() {
        const totals = this.order?.data.totals;
        if (!totals) {
            return [];
        }
        return [
            { title: 'Subtotal', value: totals.subtotal },
            { title: 'Delivery', value: totals.delivery },
            totals.discount ? { title: 'Discount', value: totals.discount } : undefined,
            { title: 'Total', value: totals.grand_total, isTotal: true }
        ].filter(i => !!i);
    }
}
